import { makeObservable, observable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import moreActions from './moreActions';

import {
    getButtons,
    generateImage,
    addWidget,
    editWidget,
    editWidgets,
    deleteWidgets,
    makeWidgetsDraft,
    makeWidgetsLive,
    uploadWidgetAssets,
    updateSchedulesFilterForButton,
} from './actions';

import {
    loadEditData,
    saveEditData,
    loadEventDisplayData,
    saveEventDisplayData,
} from './actions_persist';

import {
    getPublisherButton,
    setPublisherButton,
} from './action_publisher_button';

export default class ButtonsStore {
    version = {}
    env = null;
    editData = null;

    buttons = null;
    publisherButton = null;
    hasInactive = false;
    assets = {};
    buttonSchedules = [];
    pageInfo = {
        page: 0, /* convert this to 1 on passing */
        limit: 10,
        count: 0,
    };

    observed = {
        buttons: null,
        buttonsLoading: false,
        pageInfo: null,
        assets: {},
        buttonSchedules: null,
        publisherButton: null,
    };

    constructor () {
        withActions(this, moreActions);
        makeObservable(this, {
            observed: observable,
        });
        this.defaultBannerURLS();
    }

    getButtons = getButtons;
    generateImage = generateImage;
    addWidget = addWidget;
    editWidget = editWidget;
    editWidgets = editWidgets;
    deleteWidgets = deleteWidgets;
    makeWidgetsDraft = makeWidgetsDraft;
    makeWidgetsLive = makeWidgetsLive;
    uploadWidgetAssets = uploadWidgetAssets;
    updateSchedulesFilterForButton = updateSchedulesFilterForButton;

    /* Publisher Button */
    getPublisherButton = getPublisherButton;
    setPublisherButton = setPublisherButton;

    /* Data Persist */
    loadEditData = loadEditData;
    saveEditData = saveEditData;
    saveEventDisplayData = saveEventDisplayData;
    loadEventDisplayData = loadEventDisplayData;
}

export function useButtonsStore () {
    const { buttonsStore } = useStores();
    return buttonsStore;
}
